import Request from ".";
import { ApiRoutes } from "../constants";

export const languageListApi = async () => {
  try {
    const res = await Request.get(ApiRoutes.GET_LANGUAGES);
    return res;
  } catch (error) {
    throw error;
  }
};

export const insertTemplateApi = async (data) => {
  try {
    const res = await Request.post(ApiRoutes.INSERT_TEMPLATES, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getTemplateApi = async (data) => {
  try {
    const res = await Request.post(ApiRoutes.GET_TEMPLATES, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getTemplateListCounter = async (data) => {
  try {
    const res = await Request.post(ApiRoutes.GET_TEMPLATES_COUNTERS, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const updateTemplateApi = async (data) => {
  try {
    const res = await Request.post(ApiRoutes.UPDATE_TEMPLATES, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const deleteTemplateApi = async (data) => {
  try {
    const res = await Request.delete(ApiRoutes.DELETE_TEMPLATES, { data });
    return res;
  } catch (error) {
    throw error;
  }
};

export const syncTemplateApi = async (data) => {
  try {
    const res = await Request.post(ApiRoutes.SYNC_TEMPLATES, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const templateCategoryList = async () => {
  try {
    const res = await Request.get(ApiRoutes.GET_TEMPLATE_GATEGORY);
    return res;
  } catch (error) {
    throw error;
  }
};

export const uploadFileApi = async (data) => {
  try {
    const res = await Request.post(ApiRoutes.UPLOAD_TEMPLATE_MEDIA, data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getTemplateCountByWabaIdApi = async (data) => {
  try {
    const res = await Request.post(
      ApiRoutes.GET_TEMPLATE_COUNT_BY_WABA_ID,
      data
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const updateTemplateCategoryDetailsApi = async (data) => {
  try {
    const res = await Request.post(
      ApiRoutes.UPDATE_TEMPLATE_CATEGORY_DETAIL,
      data
    );
    return res;
  } catch (error) {
    throw error;
  }
};

export const deleteTemplateMediaApi = async (data) => {
  try {
    const res = await Request.delete(ApiRoutes.DELETE_TEMPLATE_MEDIA, { data });
    return res;
  } catch (error) {
    throw error;
  }
};

// Get Carousel Template List Api
export const getCarouselTemplateListApi = async (data) => {
  try {
    const res = await Request.post(ApiRoutes.GET_CAROUSEL_TEMPLATES, data);
    return res;
  } catch (error) {
    throw error;
  }
};
